import { Component, input, OnInit, inject } from '@angular/core';
import { QuestionItem } from '../../feedback-types';
import { ControlContainer, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { FeedbackTitleComponent } from '../feedback-title/feedback-title.component';
import { wildcardId } from '../../../../utils/feedback/feedback';

@Component({
  selector: 'app-feedback-pricing',
  imports: [ReactiveFormsModule, FeedbackTitleComponent],
  templateUrl: './feedback-pricing.component.html',
  styleUrl: './feedback-pricing.component.css',
})
export class FeedbackPricingComponent implements OnInit {
  private controlContainer = inject(ControlContainer);

  public question = input.required<QuestionItem>();
  protected form!: FormGroup;
  protected currency = '€';

  ngOnInit(): void {
    this.form = this.controlContainer.control as FormGroup;
  }

  getInputValue(id: string): string {
    const value = this.form.get(id)?.value;
    if (value && typeof value === 'string' && value.startsWith(wildcardId)) {
      return value.replace(wildcardId, '');
    }
    return value || '';
  }

  onInputChange(id: string, event: Event): void {
    const input = event.target as HTMLInputElement;
    const value = input.value;
    if (value) {
      this.form.get(id)?.setValue(wildcardId + value);
    } else {
      this.form.get(id)?.setValue(null);
    }
    this.form.get(id)?.markAsTouched();
  }

  currencyChange(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.id === 'eur') {
      this.currency = '€';
    } else {
      this.currency = '$';
    }
  }
}
